import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const userId = searchParams.get('userId');
    const username = searchParams.get('username');
    const email = searchParams.get('email');
    const role = searchParams.get('role');
    const error = searchParams.get('error');

    if (error) {
      navigate('/login?error=discord_failed');
      return;
    }

    if (token && userId) {
      // Guardar en contexto
      login(token, {
        id: userId,
        username: decodeURIComponent(username || ''),
        email: decodeURIComponent(email || ''),
        role: role || 'user'
      });
      
      // Redirigir al dashboard
      navigate('/dashboard');
    } else {
      navigate('/login?error=no_token');
    }
  }, [searchParams, login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-bg">
      <div className="text-center">
        <div className="animate-spin w-12 h-12 border-4 border-primary border-t-transparent rounded-full mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-white mb-2">Completing login...</h2>
        <p className="text-text-secondary">Please wait while we authenticate you.</p>
      </div>
    </div>
  );
};

export default AuthCallback;